import { ActivityItem, FontIcon, ILinkStyles, Icon, Link, Separator, Stack } from "@fluentui/react";
import React from "react";
import IconHelper from "../../utils/helpers/iconHelper";
import themeBase from "../../utils/theme/themeBase";
import { LineaProgreso } from "../indicadores/LineaProgreso";

interface IDescargarArchivo {
  onClick: () => void;
  isSend: boolean;
}
const linkStyle: Partial<ILinkStyles> = {
    root: {
      display: "flex",
      justifyContent: "center",
      paddingLeft: "28px",
    },
  };
export const DescargarArchivo = (props:IDescargarArchivo) => {
  return (
    <div className="ms-Grid-row">
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <br />
        <br />
        <Stack horizontalAlign="center">
          <FontIcon
            aria-label={IconHelper.ICON_EXCEL.iconProps?.iconName}
            iconName={IconHelper.ICON_EXCEL.iconProps?.iconName}
            style={{
              color: themeBase.theme.palette.green,
              fontSize: 40,
              height: 40,
              width: 40,
              margin: "0 25px",
              cursor: "pointer",
            }}
            onClick={props.onClick}
          />

          <LineaProgreso
            prefix="Generando Archivo Excel"
            ocultar={!props.isSend}
          />
        </Stack>
        <Separator>
          <Stack horizontalAlign="center">
            <Icon iconName="Download" />
          </Stack>
        </Separator>
        <Separator>
          <Stack horizontalAlign="center">
            <ActivityItem
              key="1"
              activityDescription={[
                <Link
                  styles={linkStyle}
                  key="1"
                  className={themeBase.activityClass.nameText}
                  onClick={props.onClick}
                >
                  Descargar
                </Link>,
              ]}
              timeStamp={`Archivo en formato Excel`}
            />
          </Stack>
        </Separator>
        <Separator />
      </div>
    </div>
  );
};
